import {parseMetricValueString} from 'helpers/compactMetricValue';

export type MetricDesiredDirection = 'higher' | 'lower' | 'unknown';
export type ForecastComparisonTone = 'good' | 'bad';

/**
 * Whether an actual value beat a budget or target, given the metric's desired
 * direction. Hitting the number exactly is always good; otherwise an unknown
 * direction (or a non-numeric value) has no tone.
 */
export const getForecastComparisonTone = (
  actual: string | null | undefined,
  comparison: string | null | undefined,
  direction: MetricDesiredDirection
): ForecastComparisonTone | undefined => {
  const actualValue = parseMetricValueString(actual);
  const comparisonValue = parseMetricValueString(comparison);
  if (actualValue == null || comparisonValue == null) {
    return undefined;
  }
  if (actualValue === comparisonValue) {
    return 'good';
  }
  if (direction === 'unknown') {
    return undefined;
  }
  const isAbove = actualValue > comparisonValue;
  return isAbove === (direction === 'higher') ? 'good' : 'bad';
};
